import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';
import { Fancybox } from '@fancyapps/ui';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  Fancybox.bind('[data-fancybox]', {});

  const tabButtons = document.querySelectorAll('.tab-button');
  let mediaSwiper = null;
  if (document.querySelector('.medias-carousel__carousel')) {
    mediaSwiper = new Swiper('.medias-carousel__carousel', {
      centeredSlides: true,
      spaceBetween: 20,
      slidesPerView: 1,
      loop: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },

      navigation: {
        nextEl:
          '.medias-carousel__carousel-navigation__arrows .swiper-button-next',
        prevEl:
          '.medias-carousel__carousel-navigation__arrows .swiper-button-prev',
      },
      a11y: {
        firstSlideMessage: _x(
          'This is the first slide',
          'carousel first slide label',
          'vtx'
        ),
        lastSlideMessage: _x(
          'This is the last slide',
          'carousel first slide label',
          'vtx'
        ),
        paginationBulletMessage: _x(
          'Go to slide {{index}}',
          'carousel navigation label',
          'vtx'
        ),
        prevSlideMessage: _x(
          'Previous slide',
          'carousel previous label',
          'vtx'
        ),
        nextSlideMessage: _x('Next slide', 'carousel next label', 'vtx'),
      },
    });
  }
  if (
    0 < tabButtons.length &&
    document.querySelector('.medias-carousel__carousel')
  ) {
    tabButtons.forEach(function (tabButton) {
      tabButton.addEventListener('click', function () {
        mediaSwiper.update();
      });
    });
  }
});
